import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

import {
  BlockOutlined
} from '@mui/icons-material';

import {
  actionCellSx,
  actionWrapperSx,
  blockIconSx,
  bodyCellSx,
  dateCellSx,
  emptyCellSx,
  getSignatureCellSx,
  headCellSx,
  nameCellSx,
  tableContainerSx,
  tableRowSx,
  tableSx,
  tableWrapperSx
} from './PatientDocumentStyles';

const PatientDocumentTable = ({
  documents
}) => {
  return (
    <Box sx={tableWrapperSx}>
      <TableContainer sx={tableContainerSx}>
        <Table
          stickyHeader
          sx={tableSx}>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  ...headCellSx,
                  width: '40%'
                }}>
                NAME
              </TableCell>

              <TableCell
                sx={{
                  ...headCellSx,
                  width: '15%'
                }}>
                CATEGORY
              </TableCell>

              <TableCell
                sx={{
                  ...headCellSx,
                  width: '15%'
                }}>
                DATE
              </TableCell>

              <TableCell
                sx={{
                  ...headCellSx,
                  width: '15%',
                  textAlign: 'left'
                }}>
                SIGNATURE
              </TableCell>

              <TableCell
                sx={{
                  ...headCellSx,
                  width: '15%',
                  textAlign: 'center'
                }}>
                ACTIONS
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {documents.map((doc, index) => (
              <TableRow
                key={`${doc.name}-${index}`}
                sx={tableRowSx}>
                <TableCell sx={nameCellSx}>
                  {doc.name}
                </TableCell>

                <TableCell sx={bodyCellSx}>
                  {doc.category}
                </TableCell>

                <TableCell sx={dateCellSx}>
                  {doc.date}
                </TableCell>

                <TableCell
                  sx={getSignatureCellSx(doc.status)}>
                  {doc.signature}
                </TableCell>

                <TableCell sx={actionCellSx}>
                  <Box sx={actionWrapperSx}>
                    <BlockOutlined sx={blockIconSx} />
                  </Box>
                </TableCell>
              </TableRow>
            ))}

            {documents.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={5}
                  sx={emptyCellSx}>
                  No documents found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

PatientDocumentTable.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      category: PropTypes.string,
      date: PropTypes.string,
      signature: PropTypes.string,
      status: PropTypes.string
    })
  ).isRequired
};

export default PatientDocumentTable;